import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Landing from "@/pages/Landing";
import Legal from "@/pages/Legal";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Users from "@/pages/Users";
import Reports from "@/pages/Reports";
import Verifications from "@/pages/Verifications";
import Audit from "@/pages/Audit";
import Demo from "@/pages/Demo";
import TrustSafety from "@/pages/TrustSafety";
import Communities from "@/pages/Communities";
import CommunityDetail from "@/pages/CommunityDetail";
import Vouches from "@/pages/Vouches";
import WatchParties from "@/pages/WatchParties";
import Matchmaker from "@/pages/Matchmaker";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public marketing site */}
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Legal doc="privacy" />} />
          <Route path="/terms" element={<Legal doc="terms" />} />
          <Route path="/support" element={<Legal doc="support" />} />

          {/* Admin (hidden, login-protected) */}
          <Route path="/mypersonalworkplace/login" element={<Login />} />
          <Route path="/mypersonalworkplace" element={<Shell><Dashboard /></Shell>} />
          <Route path="/mypersonalworkplace/users" element={<Shell><Users /></Shell>} />
          <Route path="/mypersonalworkplace/reports" element={<Shell><Reports /></Shell>} />
          <Route path="/mypersonalworkplace/verifications" element={<Shell><Verifications /></Shell>} />
          <Route path="/mypersonalworkplace/safety" element={<Shell><TrustSafety /></Shell>} />
          <Route path="/mypersonalworkplace/communities" element={<Shell><Communities /></Shell>} />
          <Route path="/mypersonalworkplace/communities/:communityId" element={<Shell><CommunityDetail /></Shell>} />
          <Route path="/mypersonalworkplace/vouches" element={<Shell><Vouches /></Shell>} />
          <Route path="/mypersonalworkplace/watch" element={<Shell><WatchParties /></Shell>} />
          <Route path="/mypersonalworkplace/matchmaker" element={<Shell><Matchmaker /></Shell>} />
          <Route path="/mypersonalworkplace/audit" element={<Shell><Audit /></Shell>} />
          <Route path="/mypersonalworkplace/demo" element={<Shell><Demo /></Shell>} />

          {/* Unknown paths -> public site */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors theme="dark" />
    </AuthProvider>
  );
}

export default App;
